module.exports = __webpack_public_path__ + "static/img/img-ren.78328a38.png";